export default{sources:{avif:"__VITE_ASSET__GFMX6IFL__ 400w",webp:"__VITE_ASSET__BII3hrxR__ 400w"},img:{src:"__VITE_ASSET__DT7Znzcm__",w:400,h:225}};